import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import styles from './ProductSwiperIndicator.module.less';

const ProductSwiperIndicator = props => {
  const { indicator } = props;
  const offset = {};
  offset[styles.offset] = indicator.offset;
  return (
    <div className={classNames(styles.indicatorWrapper)}>
      <div className={classNames(styles.indicatorIcon, offset)}>
        {<Icon iconName={indicator.iconName}></Icon>}
      </div>
    </div>
  );
};

ProductSwiperIndicator.propTypes = {
  indicator: PropTypes.object.isRequired,
};

export default ProductSwiperIndicator;
